export { default } from './SectionFaq';